import { LayoutContainer } from 'components/Layout';
import Text from 'components/Text';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		author: Field<string>;
		quote: Field<string>;
	};
}

export default function Quote({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<div className="max-w-col-6">
				<blockquote>
					<Text
						as="p"
						styleAs="h1"
						field={fields?.quote}
						className="mb-2 text-left"
					/>
				</blockquote>

				<Text as="p" className="text-left font-bold" field={fields?.author} />
			</div>
		</LayoutContainer>
	);
}
Quote.displayName = 'Quote';
